/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Mail_Select_UserInputs */

const en_admin_user_list_mail_select_user = /** @type {(inputs: Admin_User_List_Mail_Select_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select user`)
};

const de_admin_user_list_mail_select_user = /** @type {(inputs: Admin_User_List_Mail_Select_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzer auswählen`)
};

/**
* | output |
* | --- |
* | "Select user" |
*
* @param {Admin_User_List_Mail_Select_UserInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_mail_select_user = /** @type {((inputs?: Admin_User_List_Mail_Select_UserInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Mail_Select_UserInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_mail_select_user(inputs)
	return en_admin_user_list_mail_select_user(inputs)
});